import {
  EndCall,
  MissCall,
  NoResponseCall,
  PostImage,
  PostMessage,
  ShowImage,
  ShowText,
  TypingNow,
} from '~/app/(default-layout)/s/[storyId]/_components/chat-script-render/op';
import type { ChatScriptOperationWithIndex } from '~/app/_types/chat-script';
import { Box } from '@styled-system/jsx';
import { OperationViewableContainer } from './operation-viewable-container';

type Props = {
  ops: ChatScriptOperationWithIndex[];
};

export const OperationListRender = ({ ops }: Props) => {
  return (
    <OperationViewableContainer ops={ops}>
      {ops.map((op, index) => {
        switch (op.operationType) {
          case 'post_message_op':
            return <PostMessage key={`op-${index}`} op={op} />;
          case 'post_image_op':
            return <PostImage key={`op-${index}`} op={op} />;
          case 'show_text_op':
            return <ShowText key={`op-${index}`} op={op} />;
          case 'show_image_op':
            return <ShowImage key={`op-${index}`} op={op} />;
          case 'end_call_op':
            return <EndCall key={`op-${index}`} op={op} />;
          case 'miss_call_op':
            return <MissCall key={`op-${index}`} op={op} />;
          case 'no_response_call_op':
            return <NoResponseCall key={`op-${index}`} op={op} />;
          case 'typing_now_op':
            return <TypingNow key={`op-${index}`} op={op} />;
          case 'show_notification_op':
            // ShowNotificationはOperationViewableContainerで処理するのでここでは空要素を追加
            return <Box key={`op-${index}`} />;
          default:
            return;
        }
      })}
    </OperationViewableContainer>
  );
};
